import { authenticate, logout, getProfilesPartners } from '../services/accountService'
import Storage from '../services/common/storages/tokenStorage'

import types from './types'

const { SET_AUTHENTICATION, LOGOUT } = types

const storage = new Storage()

export function fetchAuthentication(login, password, responseCaptcha) {
  return dispatch =>
    authenticate(login, password, responseCaptcha).then(async credentials => {
      const [
        profileAtivadoresUnidas,
        profileWhiteLabelMails,
        profileParceirosMails
      ] = await getProfilesPartners(
        ['usuariosAtivadoresUnidas', 'usuariosWhiteLabel', 'usuariosPortalParceiro'],
        login
      )
      if (profileAtivadoresUnidas.length > 0) {
        credentials.at = window.btoa(login)
      }
      if (profileWhiteLabelMails.length > 0) {
        credentials.wl = window.btoa(login)
      }
      if (profileParceirosMails.length > 0) {
        credentials.pc = window.btoa(login)
      }

      storage.setAccount(credentials)
      storage.setSessionId(credentials.sessionId)

      dispatch({
        type: SET_AUTHENTICATION,
        credentials
      })

      return credentials
    })
}

export function setToken(credentials) {
  return dispatch => {
    storage.setAccount(credentials)

    return dispatch({
      type: SET_AUTHENTICATION,
      credentials
    })
  }
}

export function fetchLogout() {
  return dispatch =>
    logout().then(() => {
      dispatch({
        type: LOGOUT
      })

      return true
    })
}



// WEBPACK FOOTER //
// ./src/alelo-logic/actions/authentication.js